module.exports = __webpack_public_path__ + "public/SiteIcons/paymenyGusetIcon.svg?2f9a04be";